import React, {Component} from "react";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import * as util from "../../../util/Validator";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";

import * as routeConstants from "../../../const/route/Route";
import {Col, Row} from "reactstrap";
// import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import {Button, Dropdown, Form, Input} from "semantic-ui-react";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import * as keys from "../../../const/key/Key";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import success_icon from "../../../assets/img/sweet/success.svg";
// import cloneDeep from "lodash/cloneDeep";
import * as healthConstants from "../../../const/health/Health";
import axiosVisitor from "../../../axios/axios_visitortag";
import ResultModal from "../Dashboard/ResultModal/ResultModal";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/28/20
 * Time: 2:58 PM
 */

const initialState = {
  title: 'None', userId: 0, birthday: '',
  fname: '',
  lname: '',
  gender: 'None',
  mobile: '',
  identification_type: 'NIC',
  identification_value: '',
  city: "",
  province: null,
  postal_code: null,
  district: null,
  line1: "",
  line2: null,
  isForeignNum: false,
  isSuccess: false,

  branchId: '',meeting_floor: '',

  openModal: false, responseResult: false, responseMessage: "",
  responseClassName: "success-modal-alert", corporateName: null, corporatePhotoPath: null,
};

class App extends Component {
  state = Object.assign({}, initialState);

  handleChange = (name) => event => {
    let value = event.target.value;
    if (name === "mobile" || name === "otp") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({
          [name]: value
        })
      }
    } else {
      this.setState({
        [name]: value
      })
    }
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      [name]: value
    })
  };
  isValidate = () => {
    let condition = false;
    const {title, fname, lname, gender, mobile, identification_type, identification_value, line1, line2, district, city} = this.state;

    title === '' ? common.notifyMessage("Please enter your title") :
      gender === '' ? common.notifyMessage("Please enter your gender") :
        fname.trim() === '' ? common.notifyMessage("Please enter your first name") :
          lname.trim() === '' ? common.notifyMessage("Please enter your last name") :
            mobile.trim() === '' ? common.notifyMessage("Please enter your mobile number") :
              identification_type === '' ? common.notifyMessage("Please enter your identity value") :
                identification_value.trim() === '' ? common.notifyMessage("Please enter your identity number") :
                  // line1.trim() === '' ? common.notifyMessage("Please enter address line 1") :
                    // line2.trim() === '' ? common.notifyMessage("Please enter address line 2") :
                    //   city.trim() === '' ? common.notifyMessage("Please enter city") :
                        // district === '' ? common.notifyMessage("Please enter district") :
                          condition = util.identityValueValidator(identification_value, identification_type);

    if (condition) {
      swal({
        title: "Are you sure, you want to proceed?", icon: are_you_sure_icon, closeOnClickOutside: false,
        buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
      }).then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend(false);
            break;
          default:
            break;
        }
      });
    }
  };

  displayWarningMessage = (isError, message,corporateName,corporatePhotoPath) => {
    this.setState({openModal: true, responseClassName: `same-modal-alert`, responseResult: !isError, responseMessage: message, corporateName: corporateName, corporatePhotoPath: corporatePhotoPath});
  };

  sendToBackend = () => {
    let {pinRequired} = this.props.guest_data;
    let {userId, title, fname, lname, birthday, identification_type, identification_value, gender, city, province, postal_code, district, line1, line2} = this.state;
    const obj = {
      "title": title,
      "first_name": fname.trim(),
      "last_name": lname.trim(),
      "birthday": birthday,
      "gender": gender,
      "temporary_identification_type": identification_type,
      "temporary_identification_value": identification_value,
      "address": {
        "line1": line1 ? line1.trim() : null,
        "line2": line2,
        "city": city ? city.trim() : null,
        "district": district === "" ? null : district,
        "province": province,
        "postalCode": postal_code,
        "country": "Sri Lanka",
      }
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer" + Cookies.get(keys.ACCESS_TOKEN)
    };
    axiosTags.patch(apiConfig.GUEST_UPDATE_USER_PROFILE(userId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          swal({
            title: response.data.message,
            icon: success_icon, closeOnClickOutside: false,
            buttons: {
              cancel: 'Okay',
              dangerMode: {text: `${pinRequired ? `Proceed` : `Okay`}`, value: "action", className: "okay-btn"}
            }
          })
            .then((value) => {
              switch (value) {
                case "action":
                  pinRequired ? this.goToCheckinHandler() : this.goToThankyouPage();
                  break;
                default:
              }
            })
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, keys.GUEST_USER_USER_ROLE);
        if (result === 1) {
          this.sendToBackend();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };
  goToCheckinHandler = () => {
    if(this.props.guest_is_available_corp){
      this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/dashboard`)
    }else{
      this.submitHandler();
    }
  };
  goToThankyouPage = () => {
    Cookies.remove(keys.ACCESS_TOKEN);
    Cookies.remove(keys.REFRESH_TOKEN);
    localStorage.removeItem(keys.GUEST_CACHE);

    let {corporateName, corporatePhotoPath} = this.state;
    this.props.history.push({
      pathname: routeConstants.PUBLIC_THANK_YOU_PAGE,
      state: {corporateName: corporateName, corporatePhotoPath: corporatePhotoPath}
    });
  };
  getData = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };

    axiosTags.get(apiConfig.GUEST_VIEW_USER_PROFILE, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.fillData(response.data.user);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, keys.GUEST_USER_USER_ROLE);
        if (result === 1) {
          this.getData();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };
  callAllBuildings = (id, userRole) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };

    axiosTags.get(apiConfig.GUEST_GET_ALL_BUILDING_BY_BRANCH(id), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          let buildingList = response.data.buildingList;

          if(buildingList.length !== 0){
            let selectedBuilding = buildingList[0];
            let floorId = selectedBuilding.floors.length !== 0 ? selectedBuilding.floors[0].floor_id : 0;
            if(floorId === 0){
              this.displayWarningMessage(true, "Sorry, There are no suitable floors!" , null, null);
              return;
            }
            this.setState({meeting_floor: floorId});
            this.getData();
          }else{
            this.displayWarningMessage(true, "Sorry, There are no suitable buildings!" , null, null)
          }
        }else{
          this.displayWarningMessage(true, response.data.message , null, null);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, userRole);
        if (result === 1) {
          this.callAllBuildings(id, userRole);
        }
      })
  };
  fillData = (data) => {
    let title = data.title ? data.title : "None";
    let fname = data.firstName ? data.firstName : "";
    let lname = data.lastName ? data.lastName : "";
    let gender = data.gender ? data.gender : "None";
    let mobile = data.mobile ? data.mobile : "";
    let identification_type = data.temporary_identification_type ? data.temporary_identification_type : '';
    let identification_value = data.temporary_identification_value ? data.temporary_identification_value : '';
    let city = data.address['city'] ? data.address['city'] : "";
    let district = data.address['district'] ? data.address['district'] : "";
    let line1 = data.address['line1'] ? data.address['line1'] : "";
    let province = data.address['province'];
    let postal_code = data.address['postalCode'];
    let line2 = data.address['line2'];

    this.setState({
      userId: data.userId,
      title, fname, lname, gender, mobile,
      birthday: data.birthday,
      identification_type, identification_value,
      country: "Sri Lanka", city, province, postal_code, district, line1, line2,
      isForeignNum: data.mobile ? !data.mobile.startsWith("94") : false
    });

    if (
      // title !== "" && gender !== "" && district !== "" &&
      fname !== "" && lname !== "" && mobile !== "" && identification_type !== "" && identification_value !== ""
      // && city !== "" && line1 !== ""
    ) {
      this.setState({isSuccess: true})
    }
  };

  componentDidMount() {
    let {guestIsLogin,branchId} = this.props.guest_data;
    if (guestIsLogin) {
      this.getBranchNameUsingId();
      this.callAllBuildings(branchId, keys.GUEST_USER_USER_ROLE);
    }
  }
  getBranchNameUsingId = () => {
    let {branchId} = this.props.guest_data;
    this.setState({branchId});
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };

    axiosTags.get(apiConfig.GUEST_GET_BRANCH_NAME_BY_ID(branchId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let corpId = response.data.branchDTO.corporateId;

          this.props.setBranchNameHandler(response.data.branchDTO.name);
          let selectedDynamicList = healthConstants.GUEST_FILTER_CORPORATE_COVID.find(obj => obj.corporateId === corpId);
          let guestIsAvailable = selectedDynamicList && selectedDynamicList.selectedQuestions.length !== 0;
          this.props.setCurrentCorporateIdHandler({guestCurrentCorporateId:corpId,guestIsAvailable: guestIsAvailable});
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, keys.GUEST_USER_USER_ROLE);
        if (result === 1) {
          this.getBranchNameUsingId();
        }
      })
  };

  render() {
    let {isSuccess,openModal, responseResult, responseMessage, responseClassName} = this.state;
    let {pinRequired} = this.props.guest_data;
    return (
      <div className={"main-guest-profile"}>
        {
          openModal ? <ResultModal closeModalHandler={this.goToThankyouPage} responseClassName={responseClassName}
                                   responseResult={responseResult} responseMessage={responseMessage}/> : null
        }
        <div className={"user-reg-form"}>
          <Row>
            {pinRequired && isSuccess ?
              <Col xs={12} className={"align-right"}>
                <Button className="submit-btn ui button none-margin"
                        onClick={this.goToCheckinHandler}>Skip and Proceed</Button>
                <br/> <br/>
              </Col>
              : null}
          </Row>

          <Row>

            {/*<Col xs={12} lg={4}>*/}
              {/*<Row>*/}
                {/*<Col xs={12} lg={4}>*/}
                  {/*<Form>*/}
                    {/*<Form.Group widths='equal'>*/}
                      {/*<DrpDwn*/}
                        {/*required*/}
                        {/*tagText={<span>Title</span>}*/}
                        {/*placeholder={"Title"}*/}
                        {/*options={DropDownConst.userTitle}*/}
                        {/*value={this.state.title}*/}
                        {/*onChange={this.dropDownChange('title')}*/}
                      {/*/>*/}
                    {/*</Form.Group>*/}
                  {/*</Form>*/}
                {/*</Col>*/}
                {/*<Col xs={12} lg={8}>*/}
                  {/*<Form>*/}
                    {/*<Form.Group widths='equal'>*/}
                      {/*<DrpDwn*/}
                        {/*required*/}
                        {/*tagText={<span>Gender / <span className={"lng-sin"}>ස්ත්රී පුරුෂ භාවය</span> / <span*/}
                          {/*className={"lng-tml"}>பால்</span></span>}*/}
                        {/*placeholder={"Gender"}*/}
                        {/*options={DropDownConst.gender}*/}
                        {/*value={this.state.gender}*/}
                        {/*onChange={this.dropDownChange('gender')}*/}
                      {/*/>*/}
                    {/*</Form.Group>*/}
                  {/*</Form>*/}
                {/*</Col>*/}
              {/*</Row>*/}
            {/*</Col>*/}

            <Col xs={12} lg={12}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={<span><span>First Name</span> / <span className={"lng-sin"}>මුල් නම</span> / <span
                      className={"lng-tml"}>முதல் பெயர்</span> </span>}
                    placeholder={"First Name"}
                    value={this.state.fname}
                    onChange={this.handleChange('fname')}
                  />
                </Form.Group>
              </Form>
            </Col>

            <Col xs={12} lg={12}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={<span> <span>Last Name / </span><span className={"lng-sin"}>අවසන් නම</span> / <span
                      className={"lng-tml"}>கடைசி பெயர்</span> </span>}
                    placeholder={"Last Name"}
                    value={this.state.lname}
                    onChange={this.handleChange('lname')}
                  />

                </Form.Group>
              </Form>
            </Col>

          </Row>

          <Row>
            <Col xs={12} lg={12}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    disable
                    tagText={<span><span>Mobile / </span><span className={"lng-sin"}>ජංගම දූරකථන අංකය</span> / <span
                      className={"lng-tml"}>கைபேசி எண்</span> </span>}
                    placeholder={"07XXXXXXXX"}
                    value={this.state.mobile}
                  />

                </Form.Group>
              </Form>
            </Col>

            {/*<Col xs={12} lg={12}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*<DrpDwn*/}
                    {/*required*/}
                    {/*tagText={<span>Identification Type / <span className={"lng-sin"}>හඳුනාගැනීමේ වර්ගය</span> / <span*/}
                      {/*className={"lng-tml"}>அடையாள வகை</span> </span>}*/}
                    {/*placeholder={"Identification Type"}*/}
                    {/*options={DropDownConst.Identifications}*/}
                    {/*value={this.state.identification_type}*/}
                    {/*onChange={this.dropDownChange('identification_type')}*/}
                  {/*/>*/}
                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}

            {/*<Col xs={12} lg={12}>*/}
              {/*<Form.Group widths='equal'>*/}
                {/*<Form>*/}
                  {/*<Form.Group widths='equal'>*/}
                    {/*<TxtLbl*/}
                      {/*required*/}
                      {/*tagText={<span><span className={"lng-eng"}>Identification Number</span> / <span*/}
                        {/*className={"lng-sin"}>හැඳුනුම්පත් අංකය</span> / <span*/}
                        {/*className={"lng-tml"}>அடையாள அட்டை எண்</span>  </span>}*/}
                      {/*placeholder={"Identification Number"}*/}
                      {/*value={this.state.identification_value}*/}
                      {/*onChange={this.handleChange('identification_value')}*/}
                    {/*/>*/}

                  {/*</Form.Group>*/}
                {/*</Form>*/}
              {/*</Form.Group>*/}
            {/*</Col>*/}

            <Col xs={12} className={"required field undefined required-comp"}>
              <span>
                <span><span className={"lng-eng"}>Identification Number</span> / <span
                  className={"lng-sin"}>හැඳුනුම්පත් අංකය</span> / <span
                  className={"lng-tml"}>அடையாள அட்டை எண்</span>  </span>
              </span>
              <Input
                action={<Dropdown style={{width: 'auto!important'}}
                                  button basic floating
                                  options={DropDownConst.Identifications()}
                                  value={this.state.identification_type}
                                  onChange={this.dropDownChange('identification_type')} className={"end-"}/>}
                input={<input onChange={this.handleChange('identification_value')} value={this.state.identification_value}/>}
                style={{width: '100%', height: '38px',marginBottom:'0.6em'}} className={"custom-drop-input left action"}
                placeholder={"Identification Number"}
              />
            </Col>
          </Row>

          {/*address*/}
          <Row>
            {/*<Col xs={12} lg={4}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*<TxtLbl*/}
                    {/*required*/}
                    {/*tagText={<span><span className={"lng-eng"}>Address (Line 2)</span> / <span*/}
                      {/*className={"lng-sin"}>ලිපිනය</span> / <span className={"lng-tml"}>முகவரி</span> </span>}*/}
                    {/*placeholder={"Line 2"}*/}
                    {/*value={this.state.line2}*/}
                    {/*onChange={this.handleChange('line2')}*/}
                  {/*/>*/}

                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}
          </Row>

          <Row>
            <Col xs={12} lg={12}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    // required
                    tagText={<span><span className={"lng-eng"}>Address</span> / <span
                      className={"lng-sin"}>ලිපිනය</span> / <span className={"lng-tml"}>முகவரி </span></span>}
                    placeholder={"Address"}
                    value={this.state.line1}
                    onChange={this.handleChange('line1')}
                  />

                </Form.Group>
              </Form>
            </Col>

            <Col xs={12} lg={12}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    // required
                    tagText={<span><span className={"lng-eng"}>City</span> / <span
                      className={"lng-sin"}>නගරය</span> / <span className={"lng-tml"}>நகரம்</span> </span>}
                    placeholder={"City"}
                    value={this.state.city}
                    onChange={this.handleChange('city')}
                  />

                </Form.Group>
              </Form>
            </Col>

            {/*<Col xs={12} lg={4}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*<TxtLbl*/}
                    {/*// required*/}
                    {/*tagText={<span><span className={"lng-eng"}>Postal Code</span> / <span className={"lng-sin"}>තැපැල් කේතය</span> / <span*/}
                      {/*className={"lng-tml"}>அஞ்சல் குறியீடு</span></span>}*/}
                    {/*placeholder={"Postal Code"}*/}
                    {/*value={this.state.postal_code}*/}
                    {/*onChange={this.handleChange('postal_code')}*/}
                  {/*/>*/}

                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}

            {/*<Col xs={12} lg={12}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*{*/}
                    {/*!isForeignNum ?*/}
                      {/*<DrpDwn*/}
                        {/*required*/}
                        {/*tagText={<span><span className={"lng-eng"}>District</span> / <span*/}
                          {/*className={"lng-sin"}>දිස්ත්‍රික්කය</span> / <span className={"lng-tml"}>மாவட்டம்</span></span>}*/}
                        {/*placeholder={"District"}*/}
                        {/*options={DropDownConst.districs}*/}
                        {/*value={this.state.district}*/}
                        {/*onChange={this.dropDownChange('district')}*/}
                      {/*/> :*/}
                      {/*<TxtLbl*/}
                        {/*required*/}
                        {/*tagText={<span><span className={"lng-eng"}>District</span> / <span*/}
                          {/*className={"lng-sin"}>දිස්ත්‍රික්කය</span> / <span className={"lng-tml"}>மாவட்டம்</span></span>}*/}
                        {/*placeholder={"District"}*/}
                        {/*value={this.state.district}*/}
                        {/*onChange={this.handleChange('district')}*/}
                      {/*/>*/}
                  {/*}*/}

                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}

          </Row>
          <br/>
          <Row>
            <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px', marginTop: '15px'}}>

              <Button className="px-5"
                      onClick={() => this.isValidate(false)}>{`${pinRequired ? `Update and Proceed` : `Update Profile`}`}</Button>
              {pinRequired && isSuccess ? <Button className="submit-btn ui button mt-5"
                                                  onClick={this.goToCheckinHandler}>Skip and Proceed</Button> : null}
              {
                !pinRequired && isSuccess ? <Button className="submit-btn ui button mt-5"
                                                    onClick={this.goToThankyouPage}>Confirm Profile</Button> : null
              }
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  meetingSheduleHandler = () => {
    swal({
      title: "Do you want to proceed", icon: are_you_sure_icon, closeOnClickOutside: false,
      buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.submitHandler();
            break;
          default:
        }
      });
  };

  submitHandler = () => {
    let covidAnswers = [
      {"covid_question_id": 1, "response": false},
      {"covid_question_id": 2, "response": false},
      {"covid_question_id": 3, "response": false},
      {"covid_question_id": 4, "response": false},
      {"covid_question_id": 5, "response": false},
      {"covid_question_id": 6, "response": false},
      {"covid_question_id": 7, "response": false},
      {"covid_question_id": 8, "response": false}
    ];

    let {brachId, meeting_floor} = this.state;
    const obj = {branchId: brachId, floorId: meeting_floor, purpose: "", covidAnswers: covidAnswers};

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer" + Cookies.get(keys.ACCESS_TOKEN)
    };
    axiosVisitor.post(apiConfig.GUEST_USER_CHECK_IN, obj, {headers: headers})
      .then(response => {

        if (response.data.success) {
          this.setState({
            openModal: true,
            responseClassName: "success-modal-alert",
            responseResult: true,
            responseMessage: response.data.message,
            corporateName: response.data.corporateName,
            corporatePhotoPath: response.data.corporatePhotoPath
          })

        } else {
          if (response.data.visitorGranted === false) {
            this.setState({
              openModal: true,
              responseClassName: "err-modal-alert",
              responseResult: false,
              responseMessage: response.data.message,
              corporateName: response.data.corporateName,
              corporatePhotoPath: response.data.corporatePhotoPath
            });
            return;
          }
          common.warningAlert(response.data.message, 1, 'err-modal-alert')
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, keys.GUEST_USER_USER_ROLE);
        if (result === 1) {
          this.submitHandler();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };
}

const mapStateToProps = (state) => ({
  guest_data: state.guestUserReducer.guestUser,
  guest_corporate_id: state.guestUserReducer.guestCurrentCorporateId,
  guest_is_available_corp: state.guestUserReducer.guestIsAvailable
});
const mapDispatchToProps = (dispatch) => {
  return {
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // branch name
    setBranchNameHandler: (data) => dispatch(actionCreator.setBranchNameHandler(data)),
    // set current corp_id
    setCurrentCorporateIdHandler: (data) => dispatch(actionCreator.setCurrentCorporateId(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
